export const EVENT_TYPES = {
  GET_MANDATORY_FEEDBACK_QUESTIONS: 'GET_MANDATORY_FEEDBACK_QUESTIONS',
  POST_DATA_SUCCESS: 'POST_DATA_SUCCESS',
  UPDATE_SESSION_SUCCESS: 'UPDATE_SESSION_SUCCESS',
  SHOW_LOADER: 'SHOW_LOADER',
  HIDE_LOADER: 'HIDE_LOADER',
  SHOW_BUTTON_LOADER: 'SHOW_BUTTON_LOADER',
  HIDE_BUTTON_LOADER: 'HIDE_BUTTON_LOADER',
};
